/// <reference types="@welldone-software/why-did-you-render" />

import React from 'react';

import { isDevelopment } from '@watershed/config/env';
import { getPublicRuntimeConfig } from '@watershed/config/utils/publicRuntimeConfig';

if (
  isDevelopment() &&
  getPublicRuntimeConfig('NEXT_PUBLIC_WHY_DID_YOU_RENDER')
) {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: false,
    // include: [/./],
  });
}
